import {
  Box,
  Button,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import PropTypes from 'prop-types';

function PersonFormValidationSummary({ locations, onSelectLocation }) {
  if (locations.length === 0) return null;

  return (
    <Box mb={2}>
      <Alert severity="error">
        <Typography variant="body2">
          No se puede guardar. Hay {locations.length} {locations.length === 1
            ? 'campo por corregir.'
            : 'campos por corregir.'}
        </Typography>
        {locations.map((location) => (
          <Box key={location.fieldname} mt={0.5}>
            <Button
              color="inherit"
              onClick={() => onSelectLocation(location)}
              size="small"
              style={{
                justifyContent: 'flex-start',
                padding: 0,
                textAlign: 'left',
                textTransform: 'none',
              }}
            >
              {location.tabLabel}
              {location.groupLabel ? ` · ${location.groupLabel}` : ''}
              {`: ${location.fieldLabel} — ${location.message}`}
            </Button>
          </Box>
        ))}
      </Alert>
    </Box>
  );
}

PersonFormValidationSummary.defaultProps = {
  locations: [],
  onSelectLocation: () => {},
};

PersonFormValidationSummary.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    fieldLabel: PropTypes.string,
    fieldname: PropTypes.string,
    groupLabel: PropTypes.string,
    message: PropTypes.string,
    tabLabel: PropTypes.string,
    tabValue: PropTypes.string,
  })),
  onSelectLocation: PropTypes.func,
};

export default PersonFormValidationSummary;
